export const PV_EMAIL = 'pv@biolitecpharma.com';

// Set this to the Catalyst function URL once the backend exists.
// While null, the form falls back to opening the user's mail client.
export const AE_ENDPOINT = '/server/ae_report/submit';

const LABELS = {
  name: 'Name',
  status: 'Status',
  hospital: 'University / hospital',
  department: 'Unit / department',
  address: 'Address',
  zip: 'ZIP / postal code',
  city: 'City',
  phone: 'Phone number',
  email: 'Email',
  fax: 'Fax number',
  indication: 'Indication',
  dose: 'Dose',
  injectionDate: 'Date of Foscan injection',
  batchNumber: 'Batch number of Foscan',
  illuminationDate: 'Date of illumination',
  treatingCenter: 'Treating centre',
  country: 'Country of treating centre',
  physician: 'Treating physician',
  eventStartDate: 'Event start date',
  eventEndDate: 'Event end date',
  description: 'Description',
  patientInitials: 'Patient initials',
  patientAge: 'Patient age',
  patientGender: 'Patient gender',
};

const SECTIONS = [
  ['Reporter details', ['name', 'status', 'hospital', 'department', 'address', 'zip', 'city', 'phone', 'email', 'fax']],
  ['Product details', ['indication', 'dose', 'injectionDate', 'batchNumber', 'illuminationDate', 'treatingCenter', 'country', 'physician']],
  ['Adverse event', ['eventStartDate', 'eventEndDate', 'description']],
  ['Patient details', ['patientInitials', 'patientAge', 'patientGender']],
];

export function buildReportBody(form) {
  const lines = ['Adverse event report submitted via biolitecpharma.com', ''];

  SECTIONS.forEach(([heading, keys]) => {
    lines.push(heading.toUpperCase(), '-'.repeat(heading.length));
    keys.forEach((key) => {
      const value = String(form[key] || '').trim();
      lines.push(`${LABELS[key]}: ${value || '-'}`);
    });
    lines.push('');
  });

  lines.push(`Submitted: ${new Date().toISOString()}`);
  return lines.join('\n');
}

export function buildReportSubject(form) {
  const ref = String(form.patientInitials || '').trim();
  return `Adverse Event Report - Foscan${ref ? ` - ${ref}` : ''}`;
}

export function openMailClient(form) {
  window.location.href =
    `mailto:${PV_EMAIL}` +
    `?subject=${encodeURIComponent(buildReportSubject(form))}` +
    `&body=${encodeURIComponent(buildReportBody(form))}`;
}

export async function submitReport(form) {
  if (!AE_ENDPOINT) {
    openMailClient(form);
    return { mode: 'mailto' };
  }

  const res = await fetch(AE_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      ...form,
      subject: buildReportSubject(form),
      body: buildReportBody(form),
    }),
  });

  if (!res.ok) throw new Error(`Submission failed (${res.status})`);
  return { mode: 'api' };
}